export let ApprovalUserType;
(function (ApprovalUserType) {
  ApprovalUserType["REQUESTER"] = "REQUESTER";
  ApprovalUserType["APPROVER"] = "APPROVER";
  ApprovalUserType["NON_PARTICIPANT"] = "NON_PARTICIPANT";
})(ApprovalUserType || (ApprovalUserType = {}));